import React from 'react';
import PropTypes from 'prop-types';
import TopNav from './TopNav';
import '../theme/tokens.css';
import './AdminPage.css';

/**
 * Shared shell for the two admin form pages, and the deliberate counterpart to
 * StorePage: same sticky nav, same eyebrow-over-title header, narrower
 * container because a form reads badly at the grid's 1280px.
 *
 * TopNav is rendered without search handlers. These pages have no list to
 * filter, and a field that filtered nothing would be a dead control.
 */
export default function AdminPage({ title, children }) {
  return (
    <div className="itcAdminPage">
      <TopNav />

      <main className="itcAdminMain">
        <header className="itcAdminHeader">
          <p className="itcAdminEyebrow">ITCurves App Store · Admin</p>
          <h1 className="itcAdminTitle">{title}</h1>
        </header>

        {children}
      </main>
    </div>
  );
}

AdminPage.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};
